import { IconPresentationProps } from "@insite/mobius/Icon";
import * as React from "react";

const Camera: React.FC<IconPresentationProps> = props => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
            role="img"
        >
            {props.title && <title>{props.title}</title>}
            <path d="M 0 0 L 0 24 L 24 24 L 24 0 L 0 0 z M 9.8183594 5.4550781 L 14.181641 5.4550781 L 15.636719 7.6367188 L 18.544922 7.6367188 A 1.4545455 1.4545455 0 0 1 20 9.0917969 L 20 17.091797 A 1.4545455 1.4545455 0 0 1 18.544922 18.544922 L 5.4550781 18.544922 A 1.4545455 1.4545455 0 0 1 4 17.091797 L 4 9.0917969 A 1.4545455 1.4545455 0 0 1 5.4550781 7.6367188 L 8.3632812 7.6367188 L 9.8183594 5.4550781 z M 11.955078 9.8183594 A 2.9090909 2.9090909 0 0 0 9.0917969 12.726562 A 2.9090909 2.9090909 0 0 0 12 15.636719 A 2.9090909 2.9090909 0 0 0 14.908203 12.726562 A 2.9090909 2.9090909 0 0 0 12 9.8183594 A 2.9090909 2.9090909 0 0 0 11.955078 9.8183594 z " />
        </svg>
    );
};

export default React.memo(Camera);
